const question2 = {
    'question': 'Kto diagnozuje autyzm?',
    'answer': 'W naszym centrum w Toruniu diagnozę autyzmu dokonuje zespół odpowiednio dobranych specjalistów. W skład zespołu diagnozującego wchodzą: lekarze psychiatrzy oraz psycholodzy.'
}

export default question2;